module.exports = __webpack_public_path__ + "img/bottle_regeneration.2f0cd7a3.png";